<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--login">
            <section class="l-content-area">
                <div class="l-content">


                    <section class="p-bloc p-bloc--register">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">

                                <div class="login-box">

                                    <div class="p-login__title">
                                        <div class="logo"><img src="@/assets/img/login/logo.png" alt="hubsynch"></div>
                                        <h1>{{ $t('LABEL_REGISTER_ACCOUNT') }}</h1>
                                    </div>

                                    <!-- verify -->
                                    <section class="p-verify">
                                        <p>{{ $t('TEXT_REGISTER_VERIFY_COMPLETE_1') }}</p>

                                        <div class="p-verify__finish">
                                            <p v-html="$t('TEXT_REGISTER_VERIFY_COMPLETE_2')"></p>
                                            <ul>
                                                <li>{{ $t('TEXT_REGISTER_VERIFY_COMPLETE_3') }}</li>
                                                <li>{{ $t('TEXT_REGISTER_VERIFY_COMPLETE_4') }}</li>
                                            </ul>
                                            <div class="p-reminder__back">
                                                <div class="c-btn c-btn--tologin"><a id="link-login" href="/login">{{ $t('LABEL_BUTTON_TO_LOGIN_PAGE') }}</a></div>
                                            </div>
                                        </div>
                                    </section><!-- .p-verify -->

                                </div><!-- .bg-box -->


                            </div>
                        </div>
                    </section>


                </div><!-- .l-content -->
            </section><!-- .l-content-area -->

        </div><!-- .l-project-wrap -->

        <!-- footer -->

    </div>

</template>